import { html, TemplateResult } from "lit-html"
import { currentScreenAndDialog, repeat } from "../../.."
import {
  HookDialogActivate,
  HookDialogActivate_Type,
} from "../../../global/hooks"
import { DialogsState } from "../../dialog/sysdialogbase"
import { SYSBaseElement } from "../../sysbaseelement"

export class SYSDialogContainer extends SYSBaseElement {
  async getUI() {
    this.state.ovl.screens.nav.dialogCounter
    let dialogKeys = Object.keys(currentScreenAndDialog.dialogs)
    let res = await repeat(
      dialogKeys,
      (k) => k,
      (k) => {
        if (k === dialogKeys[dialogKeys.length - 1]) {
          // call the Dialog Activate Hook
          let dialogAndInstance = k.split("@@Ovl")
          let dialog = dialogAndInstance[0]
          let instance = dialogAndInstance[1]
          let dialogState: DialogsState =
            this.state.ovl.dialogs[dialog].instance[instance]
          let fnName = HookDialogActivate
          let fn = this.actions.app.global.hooks?.[fnName]
          if (fn) {
            fn(<HookDialogActivate_Type>{
              dialog: k,
              dialogState,
              dialogInstance: instance,
            })
          }
        }
        return html`${currentScreenAndDialog.dialogs[k]}`
      }
    )

    //resumeTracking()
    return <TemplateResult>res
  }
}
